import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from "react-oidc-context";
import App from './App';
import { EnvConfigs } from "./http-common";
import reportWebVitals from './reportWebVitals';
import { RoleBasedAuthProvider } from './contexts/RoleBasedAuthContext';

const oidcConfig = {
  authority: EnvConfigs['authority'],
  client_id: EnvConfigs['client_id'],
  redirect_uri: EnvConfigs['redirect_uri'],
  scope: "openid email profile",
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
  loadUserInfo: true,
  automaticSilentRenew: true,
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider {...oidcConfig}>
        <RoleBasedAuthProvider>
          <App />
        </RoleBasedAuthProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();